import { render, staticRenderFns } from "./NpsQuestion.vue?vue&type=template&id=5a872cd5&scoped=true"
import script from "./NpsQuestion.vue?vue&type=script&lang=js"
export * from "./NpsQuestion.vue?vue&type=script&lang=js"
import style0 from "./NpsQuestion.vue?vue&type=style&index=0&id=5a872cd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a872cd5",
  null
  
)

export default component.exports